import { Sucursal } from "./sucursal";

export class Caja{
    public constructor(
        public id: String = "",
        public nombre:String = "",
        public punto_emision:String = "",
        public empresa_id:String = "",
        public sucursal_id:String = "",
        //public cajero_id:String = "",
        public usuario_id:String = null,

        public sucursal: Sucursal = new Sucursal()
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/caja.ts